import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchData,
  fetchAllData,
  fetchUpdateData,
  fetchDeleteData
} from "../../helpers/externapi";
import MapBoxHospital from "../../Components/MapBoxHospital";
import { fetchConfigValues } from "../../Commoncomponents/CommonComponents";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

export default function HospitalPersonalDetails({ data, onActivate }) {
  const profile = data;
  const navigate = useNavigate();
  const [mocUrl, setMocUrl] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [doctorData, setDoctorData] = useState([]);
  const [spocData, setSpocData] = useState([]);
  const [hospitalPolicies, setHospitalPolicies] = useState([]);
  const [doctorTimings, setDoctorTimings] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeTab, setActiveTab] = useState("");
  const [specializations, setSpecializations] = useState([]);
  const [loading, setLoading] = useState(true); // Added missing loading state
  const location = useLocation();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const fromInactiveTab = location.state?.fromInactiveTab || false;
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [confirmationData, setConfirmationData] = useState({});

  const [isActivating, setIsActivating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [toast, setToast] = useState({
    show: false,
    message: "",
    variant: "success",
  });

  const showToast = (message, variant = "success") =>
    setToast({ show: true, message, variant });

  useEffect(() => {
    if (toast.show) {
      const t = setTimeout(() => setToast({ ...toast, show: false }), 3000);
      return () => clearTimeout(t);
    }
  }, [toast]);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };


  const [details, setDetails] = useState(data);

  useEffect(() => {
    setDetails(data);
  }, [data]);


  //  const handleActivate = async (item) => {
  //   try {
  //     setIsActivating(true);
  //     await fetchUpdateData([
  //       {
  //         columnName: "IsHospitalActive",  
  //         columnValue: 1,
  //         tableName: "Hospitals", 
  //         tableId: item.HospitalId
  //       },
  //     ]);

  //     item.IsHospitalActive = 1; 
  //     alert("Hospital activated successfully!");

  //   } catch (error) {
  //     console.error("Error activating hospital:", error);
  //   } finally {
  //     setIsActivating(false);
  //   }
  // };
  const handleActivate = async (item) => {
    try {
      setIsActivating(true);

      await fetchUpdateData([
        {
          columnName: "IsHospitalActive",
          columnValue: 1,
          tableName: "Hospitals",
          tableId: item.HospitalId,
        },
      ]);

      showToast("Hospital activated successfully!", "success");

      if (onActivate) {
        onActivate({ ...data, IsHospitalActive: 1 });
      }

      navigate("/community/details", { state: { activeTab: "active" } });
    } catch (error) {
      console.error("Error activating hospital:", error);
      showToast("Failed to activate hospital", "danger");
    } finally {
      setIsActivating(false);
    }
  };


  useEffect(() => {
    const fetchDoctorData = async () => {
      try {
        const response = await fetchAllData(
          `Doctor/GetByHospitalId/${profile.HospitalId}`
        );
        setDoctorData(response);


        if (response && response.length > 0) {
          await fetchDoctorTimings(response);
        }
      } catch (error) {
        console.error("Error fetching doctor data:", error);
      }
    };

    const fetchSpocData = async () => {
      try {
        const spocresponse = await fetchAllData(
          `HospitalContact/GetByHospitalId/${profile.HospitalId}`
        );
        setSpocData(spocresponse);
      } catch (error) {
        console.error("Error fetching spoc data:", error);
      }
    };

    const fetchSpecializations = async () => {
      try {
        const response = await fetchAllData(
          `lambdaAPI/HospitalSpecializations/GetByHospitalId/${profile.HospitalId}`
        );
        setSpecializations(response);
      } catch (error) {
        console.error("Error fetching specializations:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSpocData();
    fetchDoctorData();
    fetchSpecializations();
  }, [profile.HospitalId]);

  useEffect(() => {
    const fetchHospitalPoliciesData = async () => {
      try {
        const response = await fetchAllData(
          `HospitalPoliciesProvision/GetByHospitalId/${profile.HospitalId}`
        );
        setHospitalPolicies(response);
      } catch (error) {
        console.error("Error fetching hospital policies data:", error);
      }
    };
    fetchHospitalPoliciesData();
  }, [profile.HospitalId]);

  useEffect(() => {
    const getMocUrl = async () => {
      const { mouBucketURL, hospitalImagesURL } = await fetchConfigValues();
      setMocUrl(mouBucketURL);
      setImageUrl(hospitalImagesURL);
    };

    getMocUrl();
  }, []);

  const handleUpdateLocation = async () => {
    try {
      const response = await fetchData("Geocoding/forward", {
        hospitalId: profile.HospitalId,
      });
      window.location.reload();
    } catch (error) {
      console.error("Error fetching location data: ", error);
    }
  };

  // Navigation handlers for add buttons
  const handleAddDoctor = () => {
    navigate(`/hospitals/doctorsManagement/${profile.HospitalId}`);
  };

  const handleAddSPOC = () => {
    navigate(`/hospitals/SPOCManagement/${profile.HospitalId}`);
  };

  // Navigation handlers for edit functionality
  const handleEditDoctor = (doctorId) => {
    navigate(`/hospitals/doctorsManagement/${profile.HospitalId}/${doctorId}`);
  };

  const handleEditSPOC = (spocId) => {
    navigate(`/hospitals/SPOCManagement/${profile.HospitalId}/${spocId}`);
  };

  const fetchDoctorTimings = async (doctors) => {
    const timingsData = {};
    const today = new Date();

    // Calculate current week's Sunday (start of week)
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - today.getDay()); // Sunday

    // Calculate current week's Saturday (end of week)
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6); // Saturday

    for (const doctor of doctors) {
      try {
        // Format dates as YYYY-MM-DD without time
        const formattedStartDate = startOfWeek.toISOString().split("T")[0];
        const formattedEndDate = endOfWeek.toISOString().split("T")[0];

        const timingResponse = await fetchData(
          "lambdaAPI/DoctorTimings/GetDoctorTimingsByDateRange",
          {
            doctorId: doctor.DoctorId,
            startDate: formattedStartDate,
            endDate: formattedEndDate,
          }
        );

        timingsData[doctor.DoctorId] = timingResponse || [];
      } catch (error) {
        console.error(
          `Error fetching timings for doctor ${doctor.DoctorId}:`,
          error
        );
        timingsData[doctor.DoctorId] = [];
      }
    }

    setDoctorTimings(timingsData);
  };

  const formatTime = (timeString) => {
    if (!timeString) return "";
    const [hours, minutes] = timeString.split(":");
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${ampm}`;
  };

  const getTodayTiming = (doctorId) => {
    const today = new Date().toISOString().split("T")[0];
    const timings = doctorTimings[doctorId] || [];

    // Find all timings for today
    const todayTimings = timings.filter(
      (t) => t.ScheduleDate.split("T")[0] === today
    );

    if (todayTimings.length === 0) return null;

    // Determine status based on the API response structure
    const leaveRecord = todayTimings.find((t) => !t.IsActive && t.LeaveDate);
    const availableRecord = todayTimings.find(
      (t) => t.IsActive && t.StartTime && t.EndTime
    );
    const unavailableRecord = todayTimings.find(
      (t) => t.IsActive && t.UnavailableStartTime && t.UnavailableEndTime
    );

    const isLeave = !!leaveRecord;
    const isPartial = !!unavailableRecord && !!availableRecord;
    const isAvailable = !!availableRecord && !isLeave;

    return {
      isLeave,
      isPartial,
      isAvailable,
      availableTime: availableRecord,
      unavailableTime: unavailableRecord,
      reason: leaveRecord?.Reason || unavailableRecord?.Reason,
    };
  };

  const getWeekTimings = (doctorId) => {
    const timings = doctorTimings[doctorId] || [];
    const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    // Create empty week structure starting from Sunday
    const weekStart = new Date();
    weekStart.setDate(weekStart.getDate() - weekStart.getDay());

    const weekSchedule = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(weekStart);
      date.setDate(date.getDate() + i);
      const dateStr = date.toISOString().split("T")[0];

      const dayTimings = timings.filter(
        (t) => t.ScheduleDate.split("T")[0] === dateStr
      );
      const isToday = dateStr === new Date().toISOString().split("T")[0];

      if (dayTimings.length > 0) {
        const leaveRecord = dayTimings.find((t) => !t.IsActive && t.LeaveDate);
        const availableRecord = dayTimings.find(
          (t) => t.IsActive && t.StartTime && t.EndTime
        );
        const unavailableRecord = dayTimings.find(
          (t) => t.IsActive && t.UnavailableStartTime && t.UnavailableEndTime
        );

        const isLeave = !!leaveRecord;
        const isPartial = !!unavailableRecord && !!availableRecord;
        const isAvailable = !!availableRecord && !isLeave;

        weekSchedule.push({
          date: dateStr,
          dayOfWeek: weekDays[date.getDay()],
          isToday,
          isLeave,
          isPartial,
          isAvailable,
          availableTime: availableRecord,
          unavailableTime: unavailableRecord,
          reason: leaveRecord?.Reason || unavailableRecord?.Reason,
        });
      } else {
        weekSchedule.push({
          date: dateStr,
          dayOfWeek: weekDays[date.getDay()],
          isToday,
          isLeave: false,
          isPartial: false,
          isAvailable: false,
          availableTime: null,
          unavailableTime: null,
          reason: null,
        });
      }
    }

    return weekSchedule;
  };

  const hospitalImages = profile.HospitalImages;

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? hospitalImages.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === hospitalImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handleDelete = () => {
    setConfirmationData({
      title: "Delete Member",
      message: "Are you sure you want to delete this Member?",
      onConfirm: () => confirmhandleDelete(),
    });
    setConfirmationOpen(true);
  };

  const confirmhandleDelete = async () => {
    try {
      setIsDeleting(true);
      const response = await fetchDeleteData(`lambdaAPI/Customer/delete/${profile.HospitalId}`);
      if (response.status === false) {
        setSnackbarMessage(response.message);
        setSnackbarOpen(true);
        return;
      }
      setSnackbarMessage(`Deleted Successfully`);
      setSnackbarOpen(true);

      setTimeout(() => {
        navigate("/customers/list");
      }, 2000);
    } catch (error) {
      console.error("Error deleting event:", error);
      setSnackbarMessage("Failed to delete. Please try again.");
      setSnackbarOpen(true);

    } finally {
      setIsDeleting(false);
    }
  };

  const getPlaceholderImage = (id) => {
    return id % 2 === 0
      ? "/assets/img/avatars/doctor (1).png"
      : "/assets/img/avatars/doctor.png";
  };

  return (
    <>
      {/* Hospital Basic Info */}
      <div className="row mt-2 align-items-stretch mb-4">
        <div className="col-12 col-md-8 mb-3">
          <div
            className="card shadow-sm border-0 h-100 p-4"
            style={{ borderRadius: "16px" }}
          >
            <div className="d-flex flex-row justify-content-start align-items-center">
              {profile.Image ? (
                <img
                  src={`${imageUrl}${profile.Image}`}
                  alt=""
                  className="rounded-3 me-4"
                  style={{
                    height: "100px",
                    width: "120px",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <img
                  src={`${process.env.PUBLIC_URL}/assets/hospitaldummyimage.jpg`}
                  alt=""
                  className="rounded-3 me-4"
                  style={{
                    height: "100px",
                    width: "120px",
                    objectFit: "cover",
                  }}
                />
              )}

              <div className="flex-grow-1">
                <div className="row g-2 mb-3">
                  {/* Hospital Mobile */}
                  <div className="col-md-3">
                    <div className="d-flex align-items-center">
                      <div
                        className="icon-box bg-primary-subtle text-primary rounded-circle me-2 d-flex align-items-center justify-content-center"
                        style={{ width: "32px", height: "32px" }}
                      >
                        <i className="fas fa-phone fs-6"></i>
                      </div>
                      {profile.HospitalMobileNumber ? (
                        <a
                          href={`tel:${profile.HospitalMobileNumber}`}
                          className="text-decoration-none"
                        >
                          {profile.HospitalMobileNumber}
                        </a>
                      ) : (
                        <span className="text-muted">Not available</span>
                      )}
                    </div>
                  </div>

                  {/* Landline */}
                  <div className="col-md-3">
                    <div className="d-flex align-items-center">
                      <div
                        className="icon-box bg-info-subtle text-info rounded-circle me-2 d-flex align-items-center justify-content-center"
                        style={{ width: "32px", height: "32px" }}
                      >
                        <i className="fa-solid fa-blender-phone fs-6"></i>
                      </div>
                      {profile.Landline ? (
                        <a
                          href={`tel:${profile.Landline}`}
                          className="text-decoration-none"
                        >
                          {profile.Landline}
                        </a>
                      ) : (
                        <span className="text-muted">Not available</span>
                      )}
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-md-3">
                    <div className="d-flex align-items-center">
                      <div
                        className="icon-box bg-success-subtle text-success rounded-circle me-2 d-flex align-items-center justify-content-center"
                        style={{ width: "32px", height: "32px" }}
                      >
                        <i className="fas fa-envelope fs-6"></i>
                      </div>
                      {profile.Email ? (
                        <a
                          href={`mailto:${profile.Email}`}
                          className="text-decoration-none"
                        >
                          {profile.Email}
                        </a>
                      ) : (
                        <span className="text-muted">Not available</span>
                      )}
                    </div>
                  </div>

                  {/* No. of Beds */}
                  <div className="col-md-3">
                    <div className="d-flex align-items-center">
                      <div
                        className="icon-box bg-warning-subtle text-warning rounded-circle me-2 d-flex align-items-center justify-content-center"
                        style={{ width: "32px", height: "32px" }}
                      >
                        <i className="fa-solid fa-bed fs-6"></i>
                      </div>
                      {profile.NoOfBeds ? (
                        <span>{profile.NoOfBeds} Beds</span>
                      ) : (
                        <span className="text-muted">Not available</span>
                      )}
                    </div>


                    <div className="col-md-3">
                      {!profile.IsHospitalActive ? (
                        // Show Activate button if hospital is inactive
                        <button
                          className="btn btn-outline-success btn-sm"
                          onClick={() => handleActivate(profile)}
                          disabled={isActivating}
                          title="Activate Hospital"
                        >
                          <i className="bi bi-check-circle me-1"></i>
                          {isActivating ? "Activating..." : "Activate"}
                        </button>
                      ) : (
                        // Show Delete button if hospital is active
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={handleDelete}  // no arrow needed if no arguments
                          disabled={isDeleting}
                          title="Delete Hospital"
                        >
                          <i className="bi bi-trash me-1"></i>
                          {isDeleting ? "Deleting..." : "Delete"}
                        </button>

                      )}
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center my-3">
              <h4 className="text-dark fw-bold mb-0 me-3">
                {profile.HospitalName}
              </h4>
            </div>

            <div className="row g-3">
              <div className="col-md-3">
                <div className="d-flex align-items-center">
                  <i className="fa-solid fa-location-dot text-primary me-2"></i>
                  <span className="fw-medium">City:</span>{" "}
                  {profile.City || "N/A"}
                </div>
              </div>
              <div className="col-md-3">
                <div className="d-flex align-items-center">
                  <i className="fas fa-thumbtack text-primary me-2"></i>
                  <span className="fw-medium">Pincode:</span>{" "}
                  {profile.Pincode || "N/A"}
                </div>
              </div>
              <div className="col-md-3">
                <div className="d-flex align-items-center">
                  <i className="fas fa-map-marker-alt text-primary me-2"></i>
                  <span className="fw-medium">Mandal:</span>{" "}
                  {profile.Mandal || "N/A"}
                </div>
              </div>
              <div className="col-md-3">
                <div className="d-flex align-items-center">
                  <i className="fas fa-code text-primary me-2"></i>
                  <span className="fw-medium">Code:</span>{" "}
                  {profile.HospitalCode || "N/A"}
                </div>
              </div>
            </div>

            {/* Hospital Specialization Section - Fixed the JSX structure */}
            {!loading &&
              (profile.Specialization || specializations.length > 0) && (
                <div className="mt-3">
                  <div className="d-flex align-items-center flex-wrap gap-2">
                    <span className="fw-medium text-primary d-flex align-items-center">
                      <i className="fas fa-hospital me-2"></i>Hospital
                      Specialization:
                    </span>
                    <div className="d-flex flex-wrap gap-2">
                      {profile.Specialization &&
                        profile.Specialization.split(",").map((spec, idx) => (
                          <span
                            key={`profile-spec-${idx}`}
                            className="badge bg-primary text-white px-3 py-2 rounded-pill"
                          >
                            <i
                              className="fas fa-star-of-life me-1"
                              style={{ fontSize: "10px" }}
                            ></i>
                            {spec.trim()}
                          </span>
                        ))}

                      {specializations.length > 0 &&
                        specializations.map((spec, idx) => (
                          <span
                            key={`specializations-spec-${idx}`}
                            className="badge bg-primary text-white px-3 py-2 rounded-pill"
                          >
                            <i
                              className="fas fa-star-of-life me-1"
                              style={{ fontSize: "10px" }}
                            ></i>
                            {spec.ServiceName.trim()}
                          </span>
                        ))}
                    </div>
                  </div>
                </div>
              )}

            {profile.AddressLine1 && (
              <div className="mt-3 p-3 bg-light rounded-3">
                <i className="fas fa-map-marker-alt text-primary me-2"></i>
                <span className="fw-medium">Address:</span>{" "}
                {profile.AddressLine1}
              </div>
            )}
          </div>
        </div>

        <div className="col-12 col-md-4 mb-3">
          <div
            className="card shadow-sm border-0 h-100"
            style={{ borderRadius: "16px" }}
          >
            {profile.Latitude && profile.Longitude ? (
              <div className="h-100">
                <MapBoxHospital hospitalsData={[profile]} />
              </div>
            ) : (
              <div className="d-flex flex-column justify-content-center align-items-center h-100 p-4">
                <div className="text-center mb-4">
                  <div
                    className="bg-warning-subtle rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                    style={{ width: "64px", height: "64px" }}
                  >
                    <i className="fas fa-map-marker-alt text-warning fs-3"></i>
                  </div>
                  <h6 className="text-warning fw-semibold">
                    Location Not Available
                  </h6>
                  <p className="text-muted small mb-0">
                    Please update location coordinates
                  </p>
                </div>
                <button
                  className="btn btn-warning rounded-pill"
                  onClick={() => handleUpdateLocation()}
                >
                  <i className="fas fa-sync-alt me-2"></i>Update Location
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Full Width Cards */}
      <div className="row gy-4 mb-4">
        {/* SPOC Contacts Card */}
        <div className="col-12">
          <div
            className="card shadow-sm border-0"
            style={{ borderRadius: "16px" }}
          >
            <div className="card-header bg-white border-0 p-4 pb-2">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h5 className="mb-1 fw-bold text-dark d-flex align-items-center">
                    <div
                      className="bg-primary-subtle text-primary rounded-circle me-3 d-flex align-items-center justify-content-center"
                      style={{ width: "40px", height: "40px" }}
                    >
                      <i className="fas fa-user-tie"></i>
                    </div>
                    SPOC Contacts
                  </h5>
                  <p className="text-muted small mb-0 ms-5">
                    Hospital point of contacts
                  </p>
                </div>
                <button
                  className="btn btn-primary btn-sm rounded-pill"
                  onClick={handleAddSPOC}
                >
                  <i className="fas fa-plus me-1"></i>Add SPOC
                </button>
              </div>
            </div>

            <div className="card-body p-4 pt-2">
              {spocData && spocData.length > 0 ? (
                <div className="row g-3">
                  {spocData.map((spoc) => {
                    const badgeVariant = spoc.IsPrimary
                      ? "primary"
                      : spoc.IsSecondary
                        ? "warning"
                        : "secondary";
                    return (
                      <div
                        key={spoc.HospitalContactId}
                        className="col-12 col-md-6 col-lg-4"
                      >
                        <div className="border rounded-3 p-3 bg-light position-relative h-100">
                          <button
                            className="btn btn-sm btn-outline-primary position-absolute top-0 end-0 m-2 rounded-circle"
                            onClick={() =>
                              handleEditSPOC(spoc.HospitalContactId)
                            }
                            style={{ width: "32px", height: "32px" }}
                          >
                            <i className="fas fa-edit fs-6"></i>
                          </button>

                          <div className="d-flex align-items-start gap-3">
                            <div
                              className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                              style={{ width: "48px", height: "48px" }}
                            >
                              <i className="fas fa-user"></i>
                            </div>

                            <div className="flex-grow-1">
                              <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
                                <h6 className="mb-0 fw-bold">
                                  {spoc.FullName}
                                </h6>
                                <span
                                  className={`badge bg-${badgeVariant} text-white rounded-pill px-3 py-1`}
                                >
                                  <i
                                    className="fas fa-star me-1"
                                    style={{ fontSize: "10px" }}
                                  ></i>
                                  {spoc.IsPrimary ? "Primary" : "Secondary"}
                                </span>
                              </div>

                              <div className="mb-2">
                                <small className="text-muted d-flex align-items-center">
                                  <i className="fas fa-phone text-primary me-2"></i>
                                  <a
                                    href={`tel:${spoc.MobileNumber}`}
                                    className="text-decoration-none"
                                  >
                                    {spoc.MobileNumber || "N/A"}
                                  </a>
                                </small>
                              </div>

                              {spoc.Email && (
                                <div className="mb-2">
                                  <small className="text-muted d-flex align-items-center">
                                    <i className="fas fa-envelope text-primary me-2"></i>
                                    <a
                                      href={`mailto:${spoc.Email}`}
                                      className="text-decoration-none text-truncate"
                                    >
                                      {spoc.Email}
                                    </a>
                                  </small>
                                </div>
                              )}

                              {spoc.Qualification && (
                                <div className="mb-2">
                                  <small className="text-muted">
                                    <i className="fas fa-graduation-cap text-primary me-2"></i>
                                    <span className="badge bg-info-subtle text-info rounded-pill">
                                      {spoc.Qualification}
                                    </span>
                                  </small>
                                </div>
                              )}

                              {spoc.Address && (
                                <div>
                                  <small className="text-muted d-flex">
                                    <i
                                      className="fas fa-map-marker-alt text-primary me-2 mt-1"
                                      style={{ fontSize: "10px" }}
                                    ></i>
                                    <span className="text-truncate">
                                      {spoc.Address}
                                    </span>
                                  </small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="text-center py-4">
                  <div
                    className="bg-light rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                    style={{ width: "64px", height: "64px" }}
                  >
                    <i className="fas fa-user-tie text-muted fs-3"></i>
                  </div>
                  <h6 className="text-muted">No SPOC Contacts</h6>
                  <p className="text-muted small mb-3">
                    Add SPOC contacts to manage hospital communications
                  </p>
                  <button
                    className="btn btn-primary btn-sm rounded-pill"
                    onClick={handleAddSPOC}
                  >
                    <i className="fas fa-plus me-1"></i> Add First SPOC
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Hospital Policies Card */}
        <div className="col-12">
          <div
            className="card shadow-sm border-0"
            style={{ borderRadius: "16px" }}
          >
            <div className="card-header bg-white border-0 p-4 pb-2">
              <h5 className="mb-1 fw-bold text-dark d-flex align-items-center">
                <div
                  className="bg-warning-subtle text-warning rounded-circle me-3 d-flex align-items-center justify-content-center"
                  style={{ width: "40px", height: "40px" }}
                >
                  <i className="fas fa-clipboard-list"></i>
                </div>
                Hospital Policies
              </h5>
              <p className="text-muted small mb-0 ms-5">
                Policy provisions and guidelines
              </p>
            </div>

            <div className="card-body p-4 pt-2">
              {hospitalPolicies && hospitalPolicies.length > 0 ? (
                <div className="row g-3">
                  {hospitalPolicies.map((policy, index) => (
                    <div key={index} className="col-12 col-md-6 col-lg-4">
                      <div className="d-flex justify-content-between align-items-center p-3 border rounded-3 bg-light h-100">
                        <div className="d-flex align-items-center">
                          <div
                            className={`rounded-circle me-3 ${policy.IsActive ? "bg-success" : "bg-danger"
                              }`}
                            style={{ width: "8px", height: "8px" }}
                          ></div>
                          <div>
                            <span className="fw-medium">
                              {policy.PoliciesType}
                            </span>
                            {policy.DiscountPercentage !== undefined &&
                              policy.DiscountPercentage > 0 && (
                                <span className="ms-2 badge bg-success text-white rounded-pill px-2 py-1">
                                  <i
                                    className="fas fa-percent me-1"
                                    style={{ fontSize: "10px" }}
                                  ></i>
                                  {policy.DiscountPercentage}% discount
                                </span>
                              )}
                          </div>
                        </div>
                        <span
                          className={`badge ${policy.IsActive ? "bg-success" : "bg-danger"
                            } text-white rounded-pill px-3 py-1`}
                        >
                          <i
                            className={`fas ${policy.IsActive ? "fa-check" : "fa-times"
                              } me-1`}
                            style={{ fontSize: "10px" }}
                          ></i>
                          {policy.IsActive ? "Active" : "Inactive"}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-4">
                  <div
                    className="bg-light rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                    style={{ width: "64px", height: "64px" }}
                  >
                    <i className="fas fa-clipboard-list text-muted fs-3"></i>
                  </div>
                  <h6 className="text-muted">No Policies Available</h6>
                  <p className="text-muted small mb-0">
                    Hospital policies will be displayed here
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Medical Team Card */}
        <div className="col-12">
          <div
            className="card shadow-sm border-0"
            style={{ borderRadius: "16px" }}
          >
            <div className="card-header bg-white border-0 p-4 pb-2">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h5 className="mb-1 fw-bold text-dark d-flex align-items-center">
                    <div
                      className="bg-success-subtle text-success rounded-circle me-3 d-flex align-items-center justify-content-center"
                      style={{ width: "40px", height: "40px" }}
                    >
                      <i className="fas fa-user-md"></i>
                    </div>
                    Medical Team
                  </h5>
                  <p className="text-muted small mb-0 ms-5">
                    Hospital doctors and specialists
                  </p>
                </div>
                <button
                  className="btn btn-success btn-sm rounded-pill"
                  onClick={handleAddDoctor}
                >
                  <i className="fas fa-plus me-1"></i>Add Doctor
                </button>
              </div>
            </div>

            <div className="card-body p-4 pt-2">
              {doctorData.length > 0 ? (
                <div className="row g-4">
                  {doctorData.map((doctor, index) => {
                    const todayTiming = getTodayTiming(doctor.DoctorId);
                    const weekTimings = getWeekTimings(doctor.DoctorId);

                    return (
                      <div key={index} className="col-12">
                        <div className="border rounded-3 p-4 bg-light">
                          {/* Doctor Header */}
                          <div className="d-flex align-items-start mb-3">
                            <div
                              className="bg-success text-white rounded-circle me-3 d-flex align-items-center justify-content-center"
                              style={{ width: "48px", height: "48px" }}
                            >
                              <i className="fas fa-user-md"></i>
                            </div>
                            <div className="flex-grow-1">
                              <div className="d-flex justify-content-between align-items-start">
                                <div>
                                  <h6 className="mb-2 fw-bold">
                                    {doctor.FullName || "Unnamed Doctor"}
                                  </h6>
                                  <span className="badge bg-secondary text-white rounded-pill px-3 py-1">
                                    <i
                                      className="fas fa-graduation-cap me-1"
                                      style={{ fontSize: "10px" }}
                                    ></i>
                                    {doctor.Qualification || "Not specified"}
                                  </span>
                                </div>
                                <button
                                  className="btn btn-outline-primary btn-sm rounded-pill"
                                  onClick={() =>
                                    handleEditDoctor(doctor.DoctorId)
                                  }
                                >
                                  <i className="fas fa-edit me-1"></i>Edit
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* Contact Info */}
                          <div className="row g-2 mb-3">
                            <div className="col-md-6">
                              <div className="d-flex align-items-center p-2 border rounded-2 bg-white">
                                <i className="fas fa-phone text-primary me-2"></i>
                                <span className="text-truncate">
                                  {doctor.MobileNumber || "No phone"}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="d-flex align-items-center p-2 border rounded-2 bg-white">
                                <i className="fas fa-envelope text-primary me-2"></i>
                                <span className="text-truncate">
                                  {doctor.Email || "No email"}
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* Enhanced Specializations */}
                          {doctor.DoctorSpecialization?.length > 0 && (
                            <div className="mb-3">
                              <small className="fw-bold text-muted d-block mb-2">
                                <i className="fas fa-stethoscope me-1"></i>{" "}
                                Medical Specializations
                              </small>
                              <div className="d-flex flex-wrap gap-2">
                                {doctor.DoctorSpecialization.map(
                                  (spec, idx) => (
                                    <span
                                      key={idx}
                                      className="badge bg-primary text-white rounded-pill px-3 py-2"
                                    >
                                      <i
                                        className="fas fa-medkit me-1"
                                        style={{ fontSize: "10px" }}
                                      ></i>
                                      {spec.ServiceName}
                                    </span>
                                  )
                                )}
                              </div>
                            </div>
                          )}

                          {/* Schedule Table */}
                          <div className="border-top pt-3">
                            {todayTiming ? (
                              <div className="mt-3 p-3 bg-white border rounded-3 shadow-sm">
                                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                                  <div className="d-flex align-items-center gap-3">
                                    <div
                                      className={`rounded-circle d-flex align-items-center justify-content-center ${todayTiming.isLeave
                                        ? "bg-danger-subtle text-danger"
                                        : todayTiming.isPartial
                                          ? "bg-warning-subtle text-warning"
                                          : todayTiming.isAvailable
                                            ? "bg-success-subtle text-success"
                                            : "bg-secondary-subtle text-secondary"
                                        }`}
                                      style={{ width: "32px", height: "32px" }}
                                    >
                                      <i
                                        className={`fas ${todayTiming.isLeave
                                          ? "fa-times"
                                          : todayTiming.isPartial
                                            ? "fa-clock"
                                            : todayTiming.isAvailable
                                              ? "fa-check"
                                              : "fa-minus"
                                          }`}
                                        style={{ fontSize: "14px" }}
                                      ></i>
                                    </div>

                                    <div>
                                      <div className="d-flex align-items-center gap-2 mb-1">
                                        <strong
                                          className="text-dark"
                                          style={{ fontSize: "14px" }}
                                        >
                                          Today:
                                        </strong>
                                        <span
                                          className={`badge px-2 py-1 rounded-pill ${todayTiming.isLeave
                                            ? "bg-danger text-white"
                                            : todayTiming.isPartial
                                              ? "bg-warning text-dark"
                                              : todayTiming.isAvailable
                                                ? "bg-success text-white"
                                                : "bg-secondary text-white"
                                            }`}
                                          style={{ fontSize: "11px" }}
                                        >
                                          {todayTiming.isLeave
                                            ? "ON LEAVE"
                                            : todayTiming.isPartial
                                              ? "PARTIAL SCHEDULE"
                                              : todayTiming.isAvailable
                                                ? "AVAILABLE"
                                                : "NO SCHEDULE"}
                                        </span>
                                      </div>

                                      {todayTiming.isLeave ? (
                                        <div>
                                          <div
                                            className="text-danger fw-medium"
                                            style={{ fontSize: "13px" }}
                                          >
                                            Doctor is on leave today
                                          </div>
                                          {todayTiming.reason && (
                                            <div
                                              className="text-muted"
                                              style={{ fontSize: "11px" }}
                                            >
                                              Reason: {todayTiming.reason}
                                            </div>
                                          )}
                                        </div>
                                      ) : todayTiming.isPartial ? (
                                        <div>
                                          <div
                                            className="text-success fw-medium mb-1"
                                            style={{ fontSize: "13px" }}
                                          >
                                            Available:{" "}
                                            {todayTiming.availableTime
                                              ?.StartTime &&
                                              todayTiming.availableTime?.EndTime
                                              ? `${formatTime(
                                                todayTiming.availableTime
                                                  .StartTime
                                              )} - ${formatTime(
                                                todayTiming.availableTime
                                                  .EndTime
                                              )}`
                                              : "Time not specified"}
                                          </div>
                                          <div
                                            className="text-warning fw-medium"
                                            style={{ fontSize: "11px" }}
                                          >
                                            Break:{" "}
                                            {todayTiming.unavailableTime
                                              ?.UnavailableStartTime &&
                                              todayTiming.unavailableTime
                                                ?.UnavailableEndTime
                                              ? `${formatTime(
                                                todayTiming.unavailableTime
                                                  .UnavailableStartTime
                                              )} - ${formatTime(
                                                todayTiming.unavailableTime
                                                  .UnavailableEndTime
                                              )}`
                                              : "Break time not specified"}
                                          </div>
                                          {todayTiming.reason && (
                                            <div
                                              className="text-muted"
                                              style={{ fontSize: "11px" }}
                                            >
                                              Note: {todayTiming.reason}
                                            </div>
                                          )}
                                        </div>
                                      ) : todayTiming.isAvailable ? (
                                        <div>
                                          <div
                                            className="text-success fw-medium"
                                            style={{ fontSize: "13px" }}
                                          >
                                            {todayTiming.availableTime
                                              ?.StartTime &&
                                              todayTiming.availableTime?.EndTime
                                              ? `${formatTime(
                                                todayTiming.availableTime
                                                  .StartTime
                                              )} - ${formatTime(
                                                todayTiming.availableTime
                                                  .EndTime
                                              )}`
                                              : "Available (Time not specified)"}
                                          </div>
                                          <div
                                            className="text-muted"
                                            style={{ fontSize: "11px" }}
                                          >
                                            Full day availability
                                          </div>
                                        </div>
                                      ) : (
                                        <div>
                                          <div
                                            className="text-muted fw-medium"
                                            style={{ fontSize: "13px" }}
                                          >
                                            No schedule set for today
                                          </div>
                                          <div
                                            className="text-muted"
                                            style={{ fontSize: "11px" }}
                                          >
                                            Please check weekly schedule or
                                            contact directly
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  {/* Today Badge */}
                                  <div
                                    className="badge bg-primary text-white px-3 py-2 rounded-pill"
                                    style={{ fontSize: "10px" }}
                                  >
                                    <i className="fas fa-calendar-day me-1"></i>
                                    TODAY
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="mt-3 p-3 bg-light border rounded-3 text-center">
                                <div className="text-muted mb-2">
                                  <i
                                    className="fas fa-calendar-times"
                                    style={{ fontSize: "24px" }}
                                  ></i>
                                </div>
                                <div
                                  className="text-muted fw-medium"
                                  style={{ fontSize: "13px" }}
                                >
                                  No timing data available for today
                                </div>
                                <div
                                  className="text-muted"
                                  style={{ fontSize: "11px" }}
                                >
                                  Please check the weekly schedule below
                                </div>
                              </div>
                            )}

                            <h6 className="fw-bold mb-3 text-dark mt-2">
                              <i className="fas fa-calendar-week me-2 text-primary"></i>
                              Weekly Schedule
                            </h6>

                            <div className="table-responsive">
                              <table className="table table-sm table-bordered mb-0">
                                <thead className="table-light">
                                  <tr>
                                    {weekTimings.map((day, dayIndex) => (
                                      <th
                                        key={dayIndex}
                                        className={`text-center ${day.isToday ? "bg-primary-subtle" : ""
                                          }`}
                                        style={{ fontSize: "11px" }}
                                      >
                                        {day.dayOfWeek}
                                      </th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    {weekTimings.map((day, dayIndex) => (
                                      <td
                                        key={dayIndex}
                                        className={`text-center p-2 ${day.isToday ? "bg-primary-subtle" : ""
                                          }`}
                                        style={{
                                          fontSize: "10px",
                                          minWidth: "80px",
                                        }}
                                      >
                                        {day.isLeave ? (
                                          <div className="text-danger">
                                            <i className="fas fa-times d-block mb-1"></i>
                                            <span className="fw-medium">
                                              Leave
                                            </span>
                                            {day.reason && (
                                              <div
                                                className="text-muted"
                                                style={{ fontSize: "8px" }}
                                              >
                                                {day.reason}
                                              </div>
                                            )}
                                          </div>
                                        ) : day.isPartial ? (
                                          <div className="text-warning">
                                            <i className="fas fa-clock d-block mb-1"></i>
                                            <div className="text-success fw-medium mb-1">
                                              {formatTime(
                                                day.availableTime?.StartTime
                                              )}
                                              -
                                              {formatTime(
                                                day.availableTime?.EndTime
                                              )}
                                            </div>
                                            <div
                                              className="text-warning"
                                              style={{ fontSize: "8px" }}
                                            >
                                              Break:{" "}
                                              {formatTime(
                                                day.unavailableTime
                                                  ?.UnavailableStartTime
                                              )}
                                              -
                                              {formatTime(
                                                day.unavailableTime
                                                  ?.UnavailableEndTime
                                              )}
                                            </div>
                                          </div>
                                        ) : day.isAvailable ? (
                                          <div className="text-success">
                                            <i className="fas fa-check d-block mb-1"></i>
                                            <div className="fw-medium">
                                              {formatTime(
                                                day.availableTime?.StartTime
                                              )}
                                              -
                                              {formatTime(
                                                day.availableTime?.EndTime
                                              )}
                                            </div>
                                          </div>
                                        ) : (
                                          <div className="text-muted">
                                            <i className="fas fa-minus d-block mb-1"></i>
                                            <span>No Schedule</span>
                                          </div>
                                        )}
                                      </td>
                                    ))}
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="text-center py-4">
                  <div
                    className="bg-light rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                    style={{ width: "64px", height: "64px" }}
                  >
                    <i className="fas fa-user-md text-muted fs-3"></i>
                  </div>
                  <h6 className="text-muted">No Doctors Found</h6>
                  <p className="text-muted small mb-3">
                    Add doctors to manage their schedules
                  </p>
                  <button
                    className="btn btn-success btn-sm rounded-pill"
                    onClick={handleAddDoctor}
                  >
                    <i className="fas fa-plus me-1"></i> Add First Doctor
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Additional Information Card */}
        <div className="col-12">
          <div
            className="card shadow-sm border-0"
            style={{ borderRadius: "16px" }}
          >
            <div className="card-header bg-white border-0 p-4 pb-2">
              <h5 className="mb-1 fw-bold text-dark d-flex align-items-center">
                <div
                  className="bg-info-subtle text-info rounded-circle me-3 d-flex align-items-center justify-content-center"
                  style={{ width: "40px", height: "40px" }}
                >
                  <i className="fas fa-info-circle"></i>
                </div>
                Additional Information
              </h5>
              <p className="text-muted small mb-0 ms-5">
                Documentation and services
              </p>
            </div>

            <div className="card-body p-4 pt-2">
              {/* Hospital Documentation */}
              <div className="mb-4">
                <h6
                  className="text-muted fw-semibold mb-3 text-uppercase"
                  style={{ fontSize: "12px", letterSpacing: "1px" }}
                >
                  <i className="fas fa-folder-open me-2"></i>Documentation
                </h6>
                <div className="row g-3">
                  {[
                    {
                      label: "CIN Number",
                      value: profile.CINNumber,
                      icon: "fas fa-certificate",
                      color: "primary",
                    },
                    {
                      label: "GST Number",
                      value: profile.GSTNumber,
                      icon: "fas fa-receipt",
                      color: "success",
                    },
                    {
                      label: "Registration",
                      value: profile.HospitalRegistrationNumber,
                      icon: "fas fa-building",
                      color: "info",
                    },
                    {
                      label: "Medical Council",
                      value: profile.MedicalCounsellationNumber,
                      icon: "fas fa-id-card",
                      color: "warning",
                    },
                  ].map((item, index) => (
                    <div key={index} className="col-12 col-md-6 col-lg-3">
                      <div className="d-flex align-items-center p-3 border rounded-3 bg-light h-100">
                        <div
                          className={`bg-${item.color}-subtle text-${item.color} rounded-circle me-2 d-flex align-items-center justify-content-center`}
                          style={{
                            width: "32px",
                            height: "32px",
                            minWidth: "32px",
                          }}
                        >
                          <i className={`${item.icon} fs-6`}></i>
                        </div>
                        <div className="flex-grow-1 min-w-0">
                          <div
                            className="text-muted fw-medium"
                            style={{ fontSize: "11px" }}
                          >
                            {item.label}
                          </div>
                          <div
                            className="fw-bold text-truncate"
                            style={{ fontSize: "12px" }}
                          >
                            {item.value ? (
                              <span
                                className={`badge bg-${item.color}-subtle text-${item.color} rounded-pill px-2 py-1`}
                              >
                                {item.value}
                              </span>
                            ) : (
                              <span className="badge bg-danger-subtle text-danger rounded-pill px-2 py-1">
                                Not provided
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Files & Documentation */}
              <div className="mb-4">
                <h6
                  className="text-muted fw-semibold mb-3 text-uppercase"
                  style={{ fontSize: "12px", letterSpacing: "1px" }}
                >
                  <i className="fas fa-file-download me-2"></i>Files
                </h6>
                <div className="row g-3">
                  {[
                    {
                      label: "MOU File",
                      value: profile.MOUFileName,
                      url: profile.MOUFileName
                        ? `${mocUrl}${profile.MOUFileName}`
                        : null,
                      icon: "fas fa-file-contract",
                      color: "primary",
                    },
                    {
                      label: "IOC File",
                      value: profile.IOCFile,
                      url: profile.IOCFile
                        ? `${mocUrl}${profile.IOCFile}`
                        : null,
                      icon: "fas fa-file-pdf",
                      color: "danger",
                    },
                    {
                      label: "Agreement",
                      value: profile.IsAgreementReceived
                        ? "Received"
                        : "Not Received",
                      icon: "fas fa-handshake",
                      status: profile.IsAgreementReceived
                        ? "success"
                        : "danger",
                      color: profile.IsAgreementReceived ? "success" : "danger",
                    },
                  ].map((item, index) => (
                    <div key={index} className="col-12 col-md-4">
                      <div className="text-center p-3 border rounded-3 bg-light h-100 d-flex flex-column justify-content-between">
                        <div>
                          <div
                            className={`bg-${item.color}-subtle text-${item.color} rounded-circle mx-auto mb-2 d-flex align-items-center justify-content-center`}
                            style={{ width: "40px", height: "40px" }}
                          >
                            <i className={`${item.icon} fs-5`}></i>
                          </div>
                          <div
                            className="text-muted mb-2 fw-medium"
                            style={{ fontSize: "11px" }}
                          >
                            {item.label}
                          </div>
                        </div>
                        <div>
                          {item.url ? (
                            <a
                              className={`btn btn-sm btn-${item.color} text-white rounded-pill`}
                              href={item.url}
                              target="_blank"
                              download
                            >
                              <i className="fas fa-download me-1"></i>Download
                            </a>
                          ) : item.status ? (
                            <span
                              className={`badge bg-${item.status} text-white rounded-pill px-2 py-1`}
                            >
                              <i
                                className={`fas ${item.status === "success"
                                  ? "fa-check"
                                  : "fa-times"
                                  } me-1`}
                                style={{ fontSize: "10px" }}
                              ></i>
                              {item.value}
                            </span>
                          ) : (
                            <span className="badge bg-secondary-subtle text-secondary rounded-pill px-2 py-1">
                              <i
                                className="fas fa-exclamation-triangle me-1"
                                style={{ fontSize: "10px" }}
                              ></i>
                              Not available
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Services */}
              <div>
                <h6
                  className="text-muted fw-semibold mb-3 text-uppercase"
                  style={{ fontSize: "12px", letterSpacing: "1px" }}
                >
                  <i className="fas fa-cogs me-2"></i>Services
                </h6>
                <div className="row g-2">
                  {[
                    {
                      label: "Aarogyasri",
                      value: profile.Aarogyasri,
                      icon: "fas fa-shield-alt",
                      color: "primary",
                    },
                    {
                      label: "Front Desk Call",
                      value: profile.CallToFrontDesk,
                      icon: "fas fa-phone",
                      color: "success",
                    },
                    {
                      label: "Counselling Fee",
                      value: profile.PatientCounsellingFee,
                      icon: "fas fa-comments",
                      color: "info",
                    },
                    {
                      label: "Diagnostics Menu",
                      value: profile.MenuCardForDiagnostics,
                      icon: "fas fa-list",
                      color: "warning",
                    },
                    {
                      label: "Diagnostics Discount",
                      value: profile.DiscountOnDiagnostics,
                      icon: "fas fa-percent",
                      color: "danger",
                    },
                    {
                      label: "Free OP Consultation",
                      value: profile.IsFreeOPConsultation ? "Yes" : "No",
                      icon: "fas fa-stethoscope",
                      color: "secondary",
                    },
                  ].map((item, index) => (
                    <div
                      key={index}
                      className="col-12 col-sm-6 col-md-4 col-lg-2"
                    >
                      <div className="d-flex align-items-center p-2 border rounded-2 bg-light h-100">
                        <div
                          className={`bg-${item.color}-subtle text-${item.color} rounded-circle me-2 d-flex align-items-center justify-content-center`}
                          style={{
                            width: "28px",
                            height: "28px",
                            minWidth: "28px",
                          }}
                        >
                          <i className={`${item.icon} fs-6`}></i>
                        </div>
                        <div className="flex-grow-1 min-w-0">
                          <div
                            className="text-muted"
                            style={{ fontSize: "11px" }}
                          >
                            {item.label}
                          </div>
                          <div
                            className="fw-medium text-truncate"
                            style={{ fontSize: "12px" }}
                          >
                            {item.value ? (
                              <span
                                className={`badge bg-${item.color}-subtle text-${item.color} rounded-pill`}
                              >
                                {item.value}
                              </span>
                            ) : (
                              <span className="text-muted">Not specified</span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {toast.show && (
        <div
          className={`toast align-items-center text-white bg-${toast.variant} border-0 position-fixed top-0 end-0 m-3 show`}
          style={{ zIndex: 1090 }}
          role="alert"
        >
          <div className="d-flex">
            <div className="toast-body">{toast.message}</div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              aria-label="Close"
              onClick={() => setToast({ ...toast, show: false })}
            ></button>
          </div>
        </div>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity="success">
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </>
  );
}
